import { useEffect, useState } from "react";
import "./_ProductPanel.scss";
import "./_ProductPanelMobile.scss";
import _ProductList from "./_ProductList/_ProductList";
import _ProductAdd from "./_ProductAdd/_ProductAdd";
import _ProductEdit from "./_ProductEdit/_ProductEdit";
import { FaArrowLeft, FaSearch } from "react-icons/fa";

function _ProductPanel() {
  const productPanelStructure = [
    "PRODUCT LIST",
    "ADD NEW PRODUCT",
    "EDIT PRODUCT",
  ];
  const productPanelContent = [_ProductList, _ProductAdd, _ProductEdit];
  const [activePanel, setActivePanel] = useState(0);
  const [editIndex, setEditIndex] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(""); // ✅ add this
  const ActiveComponent = productPanelContent[activePanel];

  useEffect(() => {
    document.title = "Admin | Products";
  }, []);

  return (
    <main className="ad-prod-panel-container">
      <div className="prod-panel-header">
        {activePanel === 0 ? (
          <>
            <div className="prod-panel-title-wrapper">
              <span>{productPanelStructure[activePanel]}</span>
            </div>
            <div className="prod-panel-actions-wrapper">
              <button onClick={() => setActivePanel(1)}>ADD PRODUCTS</button>
              <div className="prod-search-bar">
                <input
                  type="text"
                  placeholder="Keyword..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)} // ✅ handle typing
                />
                <span>
                  <FaSearch />
                </span>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="prod-panel-title-wrapper">
              <span
                onClick={() => {
                  setActivePanel(0);
                  setEditIndex(null);
                }}
                className="ad-prod-back-icon"
              >
                <FaArrowLeft />
              </span>
              <span>{productPanelStructure[activePanel]}</span>
            </div>
          </>
        )}
      </div>

      {/* ✅ pass searchKeyword */}
      <ActiveComponent
        setActivePanel={setActivePanel}
        setEditIndex={setEditIndex}
        editIndex={editIndex}
        searchKeyword={searchKeyword}
      />
    </main>
  );
}

export default _ProductPanel;
